import BaseModel from '@/utils/model'
/**
 * 询价管理 零件信息
 */
export default class PartItem extends BaseModel {
    id = ''

    /**
     * 零件关联ID
     */
    rfqPartId = null

    /**
     * 供应商关联ID
     */
    rfqSupplierId = null

    /**
     * 轮次
     */
    roundNo = null

    /**
     * 原材料A(RMB)
     */
    materialCost = null

    /**
     * 进口原材料(RMB)
     */
    materialImportCost = null

    /**
     * 外购零部件B(RMB)
     */
    outsidePartCost = null

    /**
     * 进口外购零部件(RMB)
     */
    importOutsidePartCost = null

    appId = null

    /**
     * 询价单关联ID
     */
    rfqId = null

    /**
     * 零件编码
     */
    partCode = null

    /**
     * 零件名
     */
    partName = null

    /**
     * 单位
     */
    unit = null

    /**
     * 单车用量
     */
    oneCarCount = null

    /**
     * 目标价格
     */
    targetPrice = null

    /**
     * 供货状态
     */
    supplyStatus = null

    /**
     * 加工费C(RMB)
     */
    processingCost = null

    /**
     * 制造成本小计（D=A+B+C）(RMB)
     */
    productionCostSum = null

    /**
     * 管理费用E(RMB)
     */
    managementCost = null

    /**
     * 销售费用F(RMB)
     */
    saleCost = null

    /**
     * 财务费用G(RMB)
     */
    accountCost = null

    /**
     * 期间费用小计（H=E+F+G）(RMB)
     */
    midiumCostSum = null

    /**
     * 利润I(RMB)
     */
    profit = null

    /**
     * 产品单价(J=D+H+I)(RMB) -> 部件价格
     */
    productUnitPrice = null

    /**
     * 包装费K(RMB)
     */
    packageFee = null

    /**
     * 运输费L(RMB)
     */
    transportFee = null

    /**
     * 费用合计(M=J+K+L)(RMB)
     */
    feeCostSum = null

    /**
     * 总投资额(RMB) -> 工装投入
     */
    totalInvest = null

    /**
     * 分摊(N)(RMB) -> 摊销金额
     */
    amortizationMoney = null

    /**
     * 总计(不含税)(O=M+N)
     */
    totalCost = null

    /**
     * 增值税(13%)(P=O*0.13)(Q=O+P)
     */
    taxCost = null

    /**
     * 销售价格(含税)
     */
    salePriceCost = null

    /**
     * 生产厂省
     */
    factoryDistrict = null

    /**
     * 生产厂市
     */
    factoryCity = null

    /**
     * 到北京汽车/距离
     */
    distanceToBj = null

    /**
     * 生产能力
     */
    produceEnergy = null

    /**
     * 开工率
     */
    workRate = null

    /**
     * 报价人电话
     */
    tel = null

    /**
     * 报价人FAX
     */
    fax = null

    /**
     * 报价人姓名
     */
    name = null

    /**
     * 备注
     */
    remark = null

    /**
     * 职务
     */
    position = null

    /**
     * 部门
     */
    dept = null

    /**
     * 是否选中参与供货
     */
    choseFlag = null

    /**
     * 供应商ID
     */
    rfqVenderId = null

    /**
     * 供应商邮箱
     */
    rfqVenderMail = null

    /**
     * 供应商业务联系人邮箱
     */
    rfqContractMail = null

    /**
     * 供应商编码
     */
    rfqSupplierCode = null

    /**
     * 供应商名
     */
    rfqSupplierName = null

    /**
     * 项目经验
     */
    rfqSupplierExpierence = null

    /**
     * 供应商类型
     */
    rfqSupplierType = null

    /**
     * 供应商回复状态
     */
    rfqSupplierReplyStatus = null
}
